{/* <script src="https://player.vimeo.com/api/player.js"></script> */}
if (!customElements.get('workout-videos')) {
    customElements.define('workout-videos', class WorkoutVideos extends HTMLElement {
        constructor() {
            super();
            // All variables
            this.externalVideo = this.querySelector('.video-wise');
            this.videos = this.querySelectorAll('.workout__video');
            this.videosContainer = this.querySelector('.workout__videos');
            this.innerContainer = this.querySelector('.workout__inner-container');
            this.containerWidth = this.offsetWidth;
            this.playButton = this.querySelector('.workout__play-button');
            this.initiated = false;
            this.currentIndex = 0;
            this.currentVideo = 0;
            this.totalDuration = 0;
            this.overallDuration = 0;
            this.videosData = [];
            this.videoUrls = [];
            this.durations = [];
            this.players = [];
            this.loopBehavior = this.dataset.loopBehavior;
            this.playPromise;
            // Control bar
            this.controlBar = this.querySelector('.workout__control-bar-container');
            this.chapters = this.controlBar.querySelectorAll('.workout__chapter');
            this.controlBars = this.querySelectorAll('.workout__control-bar-progress');
            // Overlay display
            this.overlay = this.querySelector('.workout__overlay');
            this.expand = this.querySelector('.workout__expand');
            this.overlayTitle = this.querySelector('.workout__title');
            this.overlayReps = this.querySelector('.workout__reps');
            this.overlayDuration = this.querySelector('.workout__duration');
            // Resize behavior
            this.screenSize = (window.innerWidth > 1000) ? "desktop" : " mobile";
            this.resizeInitiated = false;
            // Audio
            this.audioContainer = this.querySelector('.workout__audio-player');
            this.state = "paused";
            this.audioLoaded = false;
            this.mute = this.dataset.mute;
            this.audioVolume = (parseFloat(this.dataset.audioVolume) / 100).toFixed(2);
            // Mobile chapterselect
            if (this.querySelector('.workout__chapter-select') != undefined) {
                this.select = this.querySelector('.workout__chapter-select').querySelector('select');
                this.selectOptions = this.select.querySelectorAll('option');
            }
            
            // Rest time
            this.restTime = this.querySelector('.video__rest-time');
            this.restTimeCounter = this.restTime.querySelector('.count');
            this.restTimePlay = false;
            this.restTimeCount = 0;
            this.restTimeExercise = parseInt(this.videosContainer.dataset.exerciseRest) || 0;
            this.restTimeSet = parseInt(this.videosContainer.dataset.setRest) || 0;
            this.restTimeInterval
            // Mute button
            this.muteButton = this.querySelector('.workout__mute');
            this.volumeState = (this.mute == "true") ? 0 : 0.5;
            // Breadcrumbs
            this.breadCrumb = document.querySelector('.workout__breadcrumb')

            setTimeout(()=> {
                this.init();
                this.initBreadCrumb();
                // window.addEventListener('resize', this.screenResize.bind(this));
            }, 50)
        }
        screenResize() {
            var currentSize = (window.innerWidth > 1000) ? "desktop" : " mobile";
            if (currentSize != this.screenSize) {
                // Reset state
                this.resizeInitiated = true;
                this.screenSize = currentSize;
                this.pause();
                this.currentIndex = 0;
                this.totalDuration = 0;
                this.videosData = [];
                this.videoUrls = [];
                this.durations = [];
                this.players = [];
                this.videos.forEach((video) => {
                    video.innerHTML = "";
                });
                this.chapters.forEach((chapter) => {
                    chapter.classList.remove("loaded");
                    chapter.classList.remove("active");
                })
                this.init();
            }
        }
        init() {
            if (this.externalVideo != undefined) {
                this.playButton.addEventListener('click', () => {
                    this.playExternal()
                });
                this.querySelector('.workout__image-placeholder').addEventListener('click', () => {
                    this.playExternal()
                });
            } else {
                this.videoReady = 0;
                console.log("Init videos")
                this.videos.forEach((video_container) => {
                    var video = video_container.querySelector('video');
                    var videoData = JSON.parse(video_container.dataset.information);
                    this.videosData.push(videoData);
                });
                this.videoLoaded();
            }
 
            
        }
        playExternal() {
            this.externalVideo.style.display = "block";
            this.externalVideo.style.zIndex = 5;
            this.querySelector('.workout__image-placeholder').style.display = "none";
            this.externalVideo.querySelector('iframe').contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
        }
        initBreadCrumb() {
            if (document.referrer != "" && document.referrer != undefined) {
                if (document.referrer.includes('/series')) {
                    let series_handle = document.referrer.split("/");
                    let series = this.breadCrumb.querySelector('.series');
                    let series_link = series.querySelector('a');
                    series_handle = series_handle[series_handle.length - 1];
                    series_handle = series_handle.replaceAll('-', " ");
                    series_handle = series_handle.split(" ")
                    series_handle = series_handle.map((word) => { 
                        return word[0].toUpperCase() + word.substring(1); 
                    }).join(" ");
                    series.classList.remove('hidden');
                    series_link.setAttribute('href', document.referrer);
                    series_link.textContent = series_handle;
                }
            }
        }
        // getCookie(name) {
        //     var nameEQ = name + "=";
        //     var ca = document.cookie.split(';');
        //     for (var i = 0; i < ca.length; i++) {
        //       var c = ca[i];
        //       while (c.charAt(0) === ' ') {
        //         c = c.substring(1, c.length);
        //       }
        //       if (c.indexOf(nameEQ) === 0) {
        //         return c.substring(nameEQ.length, c.length);
        //       }
        //     }
        //     return null;
        // }
        endRestTime() {
            clearInterval(this.restTimeInterval)
            this.restTimePlay = false;
            this.restTime.classList.remove('active');
            this.overlay.removeAttribute("hidden");
        }
        playRestTime() {
            console.log("Play rest time")
            clearInterval(this.restTimeInterval)
            this.restTimeInterval = setInterval(() => {
                this.restTimeCount -= 1;
                if (this.restTimeCount >= 0) {
                    this.restTimeCounter.innerHTML = this.secondsToHMS(this.restTimeCount);
                    this.restTimeCounter.innerHTML = this.restTimeCounter.innerHTML.replace(":", "<span>:</span>");
                } else {
                    console.log("Rest time ended")
                    this.endRestTime();
                    this.play();
                }
            }, 1000);
        }
        startRestTime(set) {
            this.overlay.setAttribute("hidden", "");
            this.restTime.classList.add('active');
            if (set) {
                this.restTimeCount = this.restTimeSet;
            } else {
                this.restTimeCount = this.restTimeExercise;
            }
            this.restTimeCounter.innerHTML = this.secondsToHMS(this.restTimeCount);
            this.restTimeCounter.innerHTML = this.restTimeCounter.innerHTML.replace(":", "<span>:</span>");
            let nextTitle = "Up Next: " + this.videosData[this.currentIndex].title;
            if (this.videos[this.currentIndex].dataset.setVideo == "true") {
                nextTitle = nextTitle + " Set " + this.videos[this.currentIndex].dataset.setCount
            }
            this.restTime.querySelector('.video__next-article-title').innerHTML = nextTitle;
        }
        videoLoaded() {
            console.log("init video")
            this.videos.forEach((video_container, index) => {
                this.overallDuration += parseFloat(this.videosData[index].duration);
                this.totalDuration += parseFloat(this.videosData[index].duration);
                this.durations.push(parseFloat(this.videosData[index].duration));
                if (video_container.dataset.setVideo == "true") {
                    if (video_container.dataset.setEnd == "true") {
                        this.overallDuration += parseFloat(this.restTimeSet);
                    } else {
                        this.overallDuration += parseFloat(this.restTimeExercise);
                    }
                }
            });
            
            this.overlayDuration.textContent = this.secondsToHMS(this.overallDuration);
            if (!this.resizeInitiated) {
                this.chapters.forEach((chapter) => {
                    chapter.addEventListener('click', this.selectChapter.bind(this));
                })
                if (this.audioContainer != undefined) {
                    this.audioPlayer = this.audioContainer.querySelector('audio');
                    this.audioDuration = this.audioPlayer.duration;
                    this.audioPlayer.volume = this.audioVolume;
                    this.audioPlayer.addEventListener('waiting', () => {
                        this.players[this.currentIndex].pause();
                    });
                    this.audioPlayer.addEventListener('canplay', () => {
                        this.audioDuration = this.audioPlayer.duration;
                        if (this.state == "play") {
                            this.playPromise = this.players[this.currentIndex].play();
                        }
                    });
                }
            } else {
                this.audioPlayer.currentTime = 0;
            }
            // Display First Video
            this.initVideo(this.currentIndex);
            this.initVideoState();
            this.initControlBar();
            this.initSelect();
            this.playButton.querySelector('button').classList.remove('disabled');
        
        }
        initSelect() {
            if (this.querySelector('.workout__chapter-select') != undefined) {
                this.select.addEventListener('input', ()=> {
                    var index = this.querySelector(`.workout__video[data-name="${this.select.value}"]`).getAttribute('index');
                    this.chapters[parseInt(index)].dispatchEvent(new CustomEvent("control:go", { bubbles: true}));
                    this.pause();
                    this.currentIndex = parseInt(index);
                    this.play();
                    // console.log(this.select.value)
                    // this.chapters[parseInt(index)].click();
                })
            }
        }
        selectChapter(event) {
            console.log("Select Chapter")
            if (this.restTimePlay) {
                this.endRestTime();
            }

            this.controlBars.forEach((progressBar) => {
                progressBar.style.width = "0%";
            })
            
            const index = parseInt(event.currentTarget.getAttribute("index"))
            const rect = event.currentTarget.getBoundingClientRect();
            const xPosition = ((event.clientX - rect.left) / rect.width);
            var seconds = 0;
            var percentage = (xPosition * 100) + "%";
            this.currentIndex = index;
            seconds = this.durations[index] * xPosition;    
            if (!this.initiated) {
                this.initiated = true;
                this.videosContainer.style.display = "block";
                // Add all other video iframes
                this.videoEmbeds.forEach((video, index) => {
                    if (index != 0) {
                        this.initVideo(index)
                    }
                })
            }
            this.play(seconds,percentage);
        }
        updateOverlay() {
            this.overlayTitle.textContent = this.videosData[this.currentIndex].title;
            if (this.videosData[this.currentIndex].reps != undefined && this.videosData[this.currentIndex].reps != "") {
                this.overlayReps.textContent = this.videosData[this.currentIndex].reps;
            } else {
                this.overlayReps.textContent = "";
            }
            

            // this.overlayDuration.textContent = this.durations.reduce((a, b) => a + b, 0);
        }
        initControlBar() {
            // this.videosData.forEach((data, index) => {
            //     this.controlBar.querySelector(`[index="${index}"]`).style.width = ((parseFloat(this.durations[index]) / parseFloat(this.totalDuration)) * 100 ) + "%";
            // });
            this.controlBar.style.display = "flex";
            document.addEventListener("fullscreenchange", (event) => {
                if (!document.fullscreenElement) {
                    this.innerContainer.classList.remove("fullscreen");
                }
            });
            this.expand.addEventListener('click', (e) => {
                if (Array.from(this.innerContainer.classList).includes('fullscreen')) {
                    this.innerContainer.classList.remove("fullscreen");
                    if (document.exitFullscreen) {
                        document.exitFullscreen();
                    } else if (document.webkitExitFullscreen) { /* Safari */
                        document.webkitExitFullscreen();
                    } else if (document.msExitFullscreen) { /* IE11 */
                        document.msExitFullscreen();
                    }
                    // document.body.classList.remove("lock");
                } else {
                    this.innerContainer.classList.add("fullscreen");
                    if (this.innerContainer.requestFullscreen) {
                        this.innerContainer.requestFullscreen();
                    } else if (this.innerContainer.webkitRequestFullscreen) { /* Safari */
                        this.innerContainer.webkitRequestFullscreen();
                    } else if (this.innerContainer.msRequestFullscreen) { /* IE11 */
                        this.innerContainer.msRequestFullscreen();
                    }
                    // document.body.classList.add("lock");
                }
            })
        }
        updateControlBar(seconds) {
            if (this.currentVideo != this.currentIndex) {
                this.currentVideo = this.currentIndex;
            } else {
                var positionPercentage = (parseFloat(seconds) / parseFloat(this.durations[this.currentIndex])) * 100;
                if (positionPercentage > 100) {
                    positionPercentage = 100;
                }
                this.controlBars[this.currentIndex].style.width = positionPercentage + "%";

                var currentDurations = this.durations.slice();
                var totalTime = this.durations.reduce((a, b) => a + b, 0);
                var allRestTime = (parseInt(this.videos[this.videos.length - 1].dataset.restCount ?? 0) * this.restTimeExercise) + ((parseInt(this.videos[this.videos.length - 1].dataset.setCount ?? 1) - 1) * this.restTimeSet);
                if (this.loopBehavior === "per exercise") {
                    allRestTime = (parseInt(this.videos[this.videos.length - 1].dataset.restCount ?? 0) * this.restTimeExercise) + (parseInt(this.videos[this.videos.length - 1].dataset.totalSet ?? 0) * this.restTimeSet);
                }
                var currentTime = parseInt(currentDurations.splice(0, this.currentIndex).reduce((a, b) => a + b, 0)) + parseInt(seconds);
                var totalRestTime = (parseInt(this.videos[this.currentIndex].dataset.restCount ?? 0) * this.restTimeExercise) + ((parseInt(this.videos[this.currentIndex].dataset.setCount ?? 1) - 1) * this.restTimeSet);
                if (this.loopBehavior === "per exercise") {
                    totalRestTime = (parseInt(this.videos[this.currentIndex].dataset.restCount ?? 0) * this.restTimeExercise) + (parseInt(this.videos[this.currentIndex].dataset.totalSet ?? 0) * this.restTimeSet);
                }
                currentTime = currentTime + totalRestTime;
                var remainingTime = (totalTime + allRestTime) - currentTime;
                this.overlayDuration.textContent = this.secondsToHMS(remainingTime);
            }
        }
        secondsToHMS(seconds) {
            // Ensure seconds is a positive integer
            seconds = Math.floor(seconds);
            if (seconds < 0) return "00:00:00";

            const hours = Math.floor(seconds / 3600);
            const minutes = Math.floor((seconds % 3600) / 60);
            const secs = seconds % 60;

            // Format the output with leading zeros
            const formattedHours = (hours === 0) ? '' : String(hours).padStart(2, '0') + ":";
            const formattedMinutes = String(minutes).padStart(2, '0') + ":";
            const formattedSeconds = String(secs).padStart(2, '0');
            var formattedTime = "";
            if (formattedHours != "00") {
                formattedTime += formattedHours + ":";
            }
            if (formattedMinutes != "00") {
                formattedTime += formattedMinutes + ":";
            }
            if (formattedSeconds != "00") {
                formattedTime += formattedSeconds + ":";
            }
            return `${formattedHours}${formattedMinutes}${formattedSeconds}`;
        }
        initVideoState() {
            if (!this.resizeInitiated) {
                this.playButton.addEventListener('click', () => {
                    this.play();
                });
                this.videosContainer.addEventListener('click', () => {
                    if (this.videos[this.currentIndex].hasAttribute("playing")) {
                        this.pause();
                    } else {
                        this.play();
                    }
                });
                this.overlay.addEventListener('click', (e)=> {
                   if (Array.from(e.target.classList).includes('workout__expand') || Array.from(e.target.classList).includes('workout__mute')) return
                    if (this.videos[this.currentIndex].hasAttribute("playing")) {
                        this.pause();
                    } else {
                        this.play();
                    }
                })
                this.muteButton.addEventListener('click', (e) => {
                    this.muteButton.classList.toggle("muted");
                    if (Array.from(this.muteButton.classList).includes('muted')) {
                        this.muteVideos();
                    } else {
                        this.unmuteVideos();
                    }
                });

            }
        }
        muteVideos() {
            // this.audioPlayer.volume = this.audioVolume;
            this.players.forEach((player) => {
                player.volume = 0;
                this.audioPlayer.volume = 0;
            });
        }
        unmuteVideos() {
            this.players.forEach((player) => {
                player.volume = this.volumeState;
                this.audioPlayer.volume = this.audioVolume;
            });
        }
        initVideo(index) {
            console.log("Init Video")
            var player = this.videos[index].querySelector('video')
            this.players.push(player);
            player.addEventListener('loadedmetadata', () => {
                this.durations[index] = player.duration;
            });
            player.addEventListener("timeupdate", this.checkTimeStamp.bind(this));
            if (this.mute == "true") {
                player.volume = 0;
            }
            if (this.audioPlayer != "" && this.audioPlayer != undefined) {
                
                player.pause();
            }
            if (this.videos[index].hasAttribute("has-next")) {
                player.addEventListener('ended', (event) => {
                    // this.videos[this.currentIndex].style.display = "none";
                    this.pause();
                    event.target.currentTime = this.durations[this.currentIndex] - 1;
                    this.currentIndex += 1;
                    this.players[this.currentIndex].currentTime = 0;
                    console.log("ENDED")
                    if (event.target.closest('.workout__video').dataset.setVideo == "true" && !event.target.closest('.workout__video').getAttribute('type').includes("Instructions")) {
                        this.restTimePlay = true;
                        if (event.target.closest('.workout__video').dataset.setEnd == "true") {
                            this.startRestTime(true);
                        } else {
                            this.startRestTime(false);
                        }
                        // return
                    }

                    this.play();
                });
            } else {
                player.addEventListener('ended', () => {
                    // this.videos[this.currentIndex].style.display = "none";
                    this.pause();
                    this.players[this.currentIndex].currentTime = 0;
                    this.audioPlayer.pause();
                    this.currentIndex = 0;
                    this.overlayDuration.textContent = this.secondsToHMS(0);
                });
            }
            player.addEventListener('waiting', () => {
                this.innerContainer.classList.add('loading');
                this.audioPlayer.pause();
                this.players[this.currentIndex].pause();
            });
            player.addEventListener('canplay', () => {
                if (this.state == "play") {
                    this.innerContainer.classList.remove('loading');
                    this.audioPlayer.play();
                    this.players[this.currentIndex].play();
                }
            });
        }

        play(time, percentage) {
            this.state = "play";
            this.chapters[parseInt(this.currentIndex)].dispatchEvent(new CustomEvent("control:go", { bubbles: true}));
            if (this.restTimePlay) {
                this.pause();
                this.playRestTime();
                
                // Needed to pause/play 
                this.videos[this.currentIndex].setAttribute("playing", "");
                this.chapters[this.currentIndex].classList.add("active");
                this.classList.add("playing");
                // Chapter display
                this.chapters.forEach((chapter) => {
                    chapter.classList.remove("active");
                });
            } else {
                this.players.forEach((player, index) => {
                    player.pause();
                    this.videos[index].style.display = "none";
                    this.videos[index].removeAttribute("playing");
                });
                // Move to desired time
                this.videos[this.currentIndex].setAttribute("playing", "");
                if (time != undefined && typeof time != "object") {
                    this.players[this.currentIndex].currentTime = time;
                }
    
                // Update mobile select
                if (this.select != undefined) {
                    this.select.value = this.videos[this.currentIndex].dataset.name;
                    this.selectOptions.forEach((option) => {
                        option.removeAttribute('selected');
                        if (this.select.value == option.value) {
                            option.setAttribute('selected', '')
                        }
                    })
                }
                
                // Hide Play Button
                this.videos[this.currentIndex].style.display = "block";
                // Chapter display
                this.chapters.forEach((chapter) => {
                    chapter.classList.remove("loaded");
                    chapter.classList.remove("active");
                });
                this.controlBars.forEach((controlBar) => {
                    if (controlBar != this.controlBars[this.currentIndex]) {
                        controlBar.style.width = 0;
                    }
                })
                for (let i = 0; i < this.currentIndex; i++) {
                    this.chapters[i].classList.add("loaded");
                }
                this.chapters[this.currentIndex].classList.add("active");
                this.classList.add("playing");
    
                if (!this.initiated) {
                    this.initiated = true;
                    this.videosContainer.style.display = "block";
                    // Add all other video iframes
                    this.videos.forEach((video, index) => {
                        if (index != 0) {
                            this.initVideo(index)
                        }
                    })
                }
                this.updateOverlay();
            }

            // Audio
            console.log("Play: " + this.currentIndex)
            if (this.audioPlayer != "" && this.audioPlayer != undefined && typeof time != "object") {
                if (time != undefined && time != NaN) {
                    var audioTime = 0;
                    var currentDurations = this.durations.slice();
                    var totalTime = parseInt(currentDurations.splice(0, this.currentIndex).reduce((a, b) => a + b, 0)) + parseInt(time);
                    var totalRestTime = (parseInt(this.videos[this.currentIndex].dataset.restCount ?? 0) * this.restTimeExercise) - ((parseInt(this.videos[this.currentIndex].dataset.setCount ?? 0) - 1) * this.restTimeSet);
                    if (this.loopBehavior == "per exercise") {
                        totalRestTime = (parseInt(this.videos[this.currentIndex].dataset.restCount ?? 0) * this.restTimeExercise) + (parseInt(this.videos[this.currentIndex].dataset.totalSet ?? 0) * this.restTimeSet);
                    }
                    totalTime += totalRestTime;
                    if (this.audioDuration > totalTime) {
                        audioTime = totalTime;
                    } else {
                        audioTime = totalTime % this.audioDuration;
                    }
                    this.audioPlayer.currentTime = audioTime;
                }
                
                this.audioPlayer.play().then(() => {
                    if (!this.restTimePlay) {
                        this.playPromise = this.players[this.currentIndex].play();
                    }
                });
            } else {
                // Play Video
                if (!this.restTimePlay) {
                    this.playPromise = this.players[this.currentIndex].play();
                }
            }
            
        }
        checkTimeStamp(event, element) {
            if  (this.players[this.currentIndex] == event.target) {
                this.updateControlBar(event.target.currentTime);
                if (this.videos[this.currentIndex].hasAttribute("has-next")) {
                // if (this.videos[index].hasAttribute("has-next")) {
                    // if (!this.videos[this.currentIndex + 1].hasAttribute('loaded') && event.seconds > (this.durations[this.currentIndex] / 2)) {
                    //     // Preload next video
                    //     this.players[this.currentIndex + 1].play();
                    //     setTimeout(()=> {
                    //         this.players[this.currentIndex + 1].pause();
                    //         this.players[this.currentIndex].play(0);
                    //     }, 50)
                    //     this.videos[this.currentIndex + 1].setAttribute("loaded", "");
                    // }
                }
            }
    
        }
        pause() {
            console.log("pause")
            this.state = "pause";
            this.videos[this.currentIndex].removeAttribute("playing");
            this.players[this.currentIndex].pause();
            this.innerContainer.classList.remove('loading');
            // this.playButton.style.display = "block";
            this.classList.remove("playing");
            if (this.audioPlayer != "" && this.audioPlayer != undefined) {
                this.audioPlayer.pause();
            }

            if (this.restTimePlay) {
                clearInterval(this.restTimeInterval)
                return
            }
        }

        async fetchVimeoOembed(videoUrl) {
            const oembedUrl = `https://vimeo.com/api/oembed.json?url=${videoUrl}`;
            return fetch(oembedUrl).then(response => response.json());
        }
    })
}